import { LockSettingType } from "../../../constants/schema.js";
//#region src/engine/modules/settings/actions.ts
var ActionType = {
	changeDatabaseName: "settings.changeDatabaseName",
	changeZoomLevel: "settings.changeZoomLevel",
	streamZoomLevel: "settings.streamZoomLevel",
	scrollTo: "settings.scrollTo",
	streamScrollTo: "settings.streamScrollTo",
	changeShow: "settings.changeShow",
	changeDatabase: "settings.changeDatabase",
	changeCanvasType: "settings.changeCanvasType",
	changeLanguage: "settings.changeLanguage",
	changeTableNameCase: "settings.changeTableNameCase",
	changeColumnNameCase: "settings.changeColumnNameCase",
	changeBracketType: "settings.changeBracketType",
	changeRelationshipDataTypeSync: "settings.changeRelationshipDataTypeSync",
	changeColumnOrder: "settings.changeColumnOrder",
	changeMaxWidthComment: "settings.changeMaxWidthComment",
	changeLockSettings: "settings.changeLockSettings",
	changeIgnoreSaveSettings: "settings.changeIgnoreSaveSettings",
	changeDDLScript: "settings.changeDDLScript",
	changeNameViewMode: "settings.changeNameViewMode"
};
var CodeSettingLocks = {
	language: LockSettingType.language,
	tableNameCase: LockSettingType.tableNameCase,
	columnNameCase: LockSettingType.columnNameCase,
	bracketType: LockSettingType.bracketType
};
//#endregion
export { ActionType, CodeSettingLocks };
